// extracted by mini-css-extract-plugin
module.exports = {"frame":"Tree_frame__1bW8O","content":"Tree_content___fgjH","toggle":"Tree_toggle__2aD99","nonToggle":"Tree_nonToggle__2o4N1","active":"Tree_active__1oqj2"};